import React, { useState, useEffect } from 'react';
import { GetLocalStorageParsed } from '../../../Utils/Utils';

export function checkPermission(adminParentModuleId, adminModuleId, permissionType) {
    // Fetch the user details from local storage synchronously
    let userDetail = {};
    const storedData = sessionStorage.getItem("userDetail") || localStorage.getItem("userDetail");
    let permissions = null;

    if (storedData && storedData !== "undefined") {
        try {
            userDetail = JSON.parse(storedData);
        } catch (error) {
            return false;
        }
    } else {
        return false;
    }

    // if (localStorage.getItem("userPermission")) {
    //     permissions = JSON.parse(localStorage.getItem("userPermission"));
    // } else {
    //     permissions = userDetail?.permissions;
    // }

    // Ensure superadmin check works correctly
    if (userDetail.user_type && userDetail.user_type === '1' && userDetail.roles === 'superadmin') {
        return true;
    }

    if (userDetail && userDetail.permissions && userDetail.permissions.length > 0) {
        const permission = userDetail.permissions.find(
            (perm) =>
                perm.admin_parent_module_id === adminParentModuleId &&
                perm.admin_module_id === adminModuleId
        );

        // Return true if the permission matches and is set to "true", otherwise false
        return !!(permission && permission.module_permission[permissionType] === "true");
    }

    // If no valid permissions or conditions match, return true as per the new requirement
    return true;
}

const PermissionChecker = ({ adminParentModuleId, adminModuleId, permissionType, children }) => {
    const [hasPermission, setHasPermission] = useState(() =>
        checkPermission(adminParentModuleId, adminModuleId, permissionType)
    );

    useEffect(() => {
        // Perform permission check synchronously
        const permission = checkPermission(adminParentModuleId, adminModuleId, permissionType);
        setHasPermission(permission);
    }, [adminParentModuleId, adminModuleId, permissionType]);

    return hasPermission ? <>{children}</> : null;
};

export const permissionsConfig = {
    // Categories Management
    viewCategories: { role: "3", action: "17", type: "view" },
    addCategories: { role: "3", action: "17", type: "add" },
    editCategories: { role: "3", action: "17", type: "edit" },
    deleteCategories: { role: "3", action: "17", type: "delete" },

    viewSubCategories: { role: "3", action: "18", type: "view" },
    addSubCategory: { role: "3", action: "18", type: "add" },
    editSubCategory: { role: "3", action: "18", type: "edit" },
    deleteSubCategory: { role: "3", action: "18", type: "delete" },

    viewGuidelines: { role: "3", action: "19", type: "view" },
    addGuidelines: { role: "3", action: "19", type: "add" },
    editGuidelines: { role: "3", action: "19", type: "edit" },
    deleteGuidelines: { role: "3", action: "19", type: "delete" },

    viewCategoryFAQList: { role: "3", action: "60", type: "view" },
    addCategoryFAQList: { role: "3", action: "60", type: "add" },
    editCategoryFAQList: { role: "3", action: "60", type: "edit" },
    deleteCategoryFAQList: { role: "3", action: "60", type: "delete" },

    viewDocumentList: { role: "3", action: "61", type: "view" },
    addDocumentList: { role: "3", action: "61", type: "add" },
    editDocumentList: { role: "3", action: "61", type: "edit" },
    deleteDocumentList: { role: "3", action: "61", type: "delete" },

    viewCategoryFees: { role: "3", action: "75", type: "view" },
    addCategoryFees: { role: "3", action: "75", type: "add" },
    editCategoryFees: { role: "3", action: "75", type: "edit" },
    deleteCategoryFees: { role: "3", action: "75", type: "delete" },
    

    // Form Management
    viewFormTabs: { role: "58", action: "59", type: "view" },
    addFormTabs: { role: "58", action: "59", type: "add" },
    editFormTabs: { role: "58", action: "59", type: "edit" },
    deleteFormTabs: { role: "58", action: "59", type: "delete" },
    
    viewFormSection: { role: "58", action: "62", type: "view" },
    addFormSection: { role: "58", action: "62", type: "add" },
    editFormSection: { role: "58", action: "62", type: "edit" },
    deleteFormSection: { role: "58", action: "62", type: "delete" },

    viewFormSubSection: { role: "58", action: "63", type: "view" },
    addFormSubSection: { role: "58", action: "63", type: "add" },
    editFormSubSection: { role: "58", action: "63", type: "edit" },
    deleteFormSubSection: { role: "58", action: "63", type: "delete" },

    viewFormFields: { role: "58", action: "64", type: "view" },
    addFormFields: { role: "58", action: "64", type: "add" },
    editFormFields: { role: "58", action: "64", type: "edit" },
    deleteFormFields: { role: "58", action: "64", type: "delete" },

    viewFormDropdowns: { role: "58", action: "65", type: "view" },
    addFormDropdowns: { role: "58", action: "65", type: "add" },
    editFormDropdowns: { role: "58", action: "65", type: "edit" },
    deleteFormDropdowns: { role: "58", action: "65", type: "delete" },

    viewEmployeeDesignation: { role: "58", action: "66", type: "view" },
    addEmployeeDesignation: { role: "58", action: "66", type: "add" },
    editEmployeeDesignation: { role: "58", action: "66", type: "edit" },
    deleteEmployeeDesignation: { role: "58", action: "66", type: "delete" },

    
    // Application Management
    viewTotalApplications: { role: "5", action: "23", type: "view" },
    editTotalApplications: { role: "5", action: "23", type: "edit" },
    deleteTotalApplications: { role: "5", action: "23", type: "delete" },

    viewNewApplications: { role: "5", action: "24", type: "view" },
    editNewApplications: { role: "5", action: "24", type: "edit" },
    deleteNewApplications: { role: "5", action: "24", type: "delete" },

    viewUnderReviewApplications: { role: "5", action: "25", type: "view" },
    editUnderReviewApplications: { role: "5", action: "25", type: "edit" },
    deleteUnderReviewApplications: { role: "5", action: "25", type: "delete" },

    viewPendingApplications: { role: "5", action: "26", type: "view" },
    editPendingApplications: { role: "5", action: "26", type: "edit" },
    deletePendingApplications: { role: "5", action: "26", type: "delete" },

    viewApprovedApplications: { role: "5", action: "67", type: "view" },
    editApprovedApplications: { role: "5", action: "67", type: "edit" },
    deleteApprovedApplications: { role: "5", action: "67", type: "delete" },

    viewRejectedApplications: { role: "5", action: "68", type: "view" },
    editRejectedApplications: { role: "5", action: "68", type: "edit" },
    deleteRejectedApplications: { role: "5", action: "68", type: "delete" },

    viewPaymentDocumentRejectedApplications: { role: "5", action: "150", type: "view" },
    editPaymentDocumentRejectedApplications: { role: "5", action: "150", type: "edit" },
    deletePaymentDocumentRejectedApplications: { role: "5", action: "150", type: "delete" },

    viewExpiredApplications: { role: "5", action: "76", type: "view" },
    editExpiredApplications: { role: "5", action: "76", type: "edit" },
    deleteExpiredApplications: { role: "5", action: "76", type: "delete" },

    viewDisabledApplications: { role: "5", action: "77", type: "view" },
    editDisabledApplications: { role: "5", action: "77", type: "edit" },
    deleteDisabledApplications: { role: "5", action: "77", type: "delete" },


    // Draft Applications
    viewDraftApplications: { role: "116", action: "117", type: "view" },
    editDraftApplications: { role: "116", action: "117", type: "edit" },
    deleteDraftApplications: { role: "116", action: "117", type: "delete" },


    // Withdrawal Applications
    viewWithdrawalApplications: { role: "122", action: "130", type: "view" },
    editWithdrawalApplications: { role: "122", action: "130", type: "edit" },
    deleteWithdrawalApplications: { role: "122", action: "130", type: "delete" },


    // Renew Application Management 
    viewRenewTotalApplications: { role: "118", action: "138", type: "view" },
    editRenewTotalApplications: { role: "118", action: "138", type: "edit" },
    deleteRenewTotalApplications: { role: "118", action: "138", type: "delete" },

    viewRenewNewApplications: { role: "118", action: "139", type: "view" },
    editRenewNewApplications: { role: "118", action: "139", type: "edit" },
    deleteRenewNewApplications: { role: "118", action: "139", type: "delete" },

    viewRenewUnderReviewApplications: { role: "118", action: "140", type: "view" },
    editRenewUnderReviewApplications: { role: "118", action: "140", type: "edit" },
    deleteRenewUnderReviewApplications: { role: "118", action: "140", type: "delete" },

    viewRenewPendingApplications: { role: "118", action: "141", type: "view" },
    editRenewPendingApplications: { role: "118", action: "141", type: "edit" },
    deleteRenewPendingApplications: { role: "118", action: "141", type: "delete" },

    viewRenewApprovedApplications: { role: "118", action: "142", type: "view" },
    editRenewApprovedApplications: { role: "118", action: "142", type: "edit" },
    deleteRenewApprovedApplications: { role: "118", action: "142", type: "delete" },

    viewRenewRejectedApplications: { role: "118", action: "143", type: "view" },
    editRenewRejectedApplications: { role: "118", action: "143", type: "edit" },
    deleteRenewRejectedApplications: { role: "118", action: "143", type: "delete" },

    viewRenewPaymentDocumentRejectedApplications: { role: "118", action: "151", type: "view" },
    editRenewPaymentDocumentRejectedApplications: { role: "118", action: "151", type: "edit" },
    deleteRenewPaymentDocumentRejectedApplications: { role: "118", action: "151", type: "delete" },

    viewRenewExpiredApplications: { role: "118", action: "144", type: "view" },
    editRenewExpiredApplications: { role: "118", action: "144", type: "edit" },
    deleteRenewExpiredApplications: { role: "118", action: "144", type: "delete" },

    viewRenewDisabledApplications: { role: "118", action: "145", type: "view" },
    editRenewDisabledApplications: { role: "118", action: "145", type: "edit" },
    deleteRenewDisabledApplications: { role: "118", action: "145", type: "delete" },


    // Transactions
    viewTransactions: { role: "120", action: "121", type: "view" },


    // Certificate permissions
    certificates: { role: "6", action: "27", type: "view" },
    expired: { role: "6", action: "29", type: "view" },
    viewCertType: { role: "6", action: "74", type: "view" },
    editCertType: { role: "6", action: "74", type: "edit" },
    addCertType: { role: "6", action: "74", type: "add" },
    

    // Home Page Management
    viewLogin: { role: "10", action: "38", type: "view" },
    editAdminLogin: { role: "10", action: "38", type: "edit" },
    deleteAdminLogin: { role: "10", action: "38", type: "delete" },

    viewResetPassword: { role: "10", action: "39", type: "view" },
    editResetPassword: { role: "10", action: "39", type: "edit" },
    deleteResetPassword: { role: "10", action: "39", type: "delete" },

    viewForgotPassword: { role: "10", action: "40", type: "view" },
    editForgotPassword: { role: "10", action: "40", type: "edit" },
    deleteForgotPassword: { role: "10", action: "40", type: "delete" },

    viewRegistration: { role: "10", action: "41", type: "view" },
    editRegistration: { role: "10", action: "41", type: "edit" },
    deleteRegistration: { role: "10", action: "41", type: "delete" },

    viewHeaderContent: { role: "10", action: "42", type: "view" },
    editHeaderContent: { role: "10", action: "42", type: "edit" },
    deleteHeaderContent: { role: "10", action: "42", type: "delete" },

    viewContactUs: { role: "10", action: "43", type: "view" },
    addContactUs: { role: "10", action: "43", type: "add" },
    editContactUs: { role: "10", action: "43", type: "edit" },
    deleteContactUs: { role: "10", action: "43", type: "delete" },

    viewWebsiteLogo: { role: "10", action: "44", type: "view" },
    editWebsiteLogo: { role: "10", action: "44", type: "edit" },
    deleteWebsiteLogo: { role: "10", action: "44", type: "delete" },

    viewHeaderPages: { role: "10", action: "45", type: "view" },
    addHeaderPage: { role: "10", action: "45", type: "add" },
    editHeaderPages: { role: "10", action: "45", type: "edit" },
    deleteHeaderPages: { role: "10", action: "45", type: "delete" },

    viewBanner: { role: "10", action: "46", type: "view" },
    addBanner: { role: "10", action: "46", type: "add" },
    editBanner: { role: "10", action: "46", type: "edit" },
    deleteBanner: { role: "10", action: "46", type: "delete" },

    viewBannerLinks: { role: "10", action: "47", type: "view" },
    addBannerLinks: { role: "10", action: "47", type: "add" },
    editBannerLinks: { role: "10", action: "47", type: "edit" },
    deleteBannerLinks: { role: "10", action: "47", type: "delete" },

    viewRegistrationStep: { role: "10", action: "106", type: "view" },
    addRegistrationStep: { role: "10", action: "106", type: "add" },
    editRegistrationStep: { role: "10", action: "106", type: "edit" },
    deleteRegistrationStep: { role: "10", action: "106", type: "delete" },

    viewSocialMediaLinks: { role: "10", action: "107", type: "view" },
    addSocialMediaLinks: { role: "10", action: "107", type: "add" },
    editSocialMediaLinks: { role: "10", action: "107", type: "edit" },
    deleteSocialMediaLinks: { role: "10", action: "107", type: "delete" },

    viewTravelTradeLinks: { role: "10", action: "108", type: "view" },
    addTravelTradeLinks: { role: "10", action: "108", type: "add" },
    editTravelTradeLinks: { role: "10", action: "108", type: "edit" },
    deleteTravelTradeLinks: { role: "10", action: "108", type: "delete" },

    viewTopFooterPages: { role: "10", action: "109", type: "view" },
    addTopFooterPages: { role: "10", action: "109", type: "add" },
    editTopFooterPages: { role: "10", action: "109", type: "edit" },
    deleteTopFooterPages: { role: "10", action: "109", type: "delete" },

    viewBottomFooterPages: { role: "10", action: "110", type: "view" },
    addBottomFooterPages: { role: "10", action: "110", type: "add" },
    editBottomFooterPages: { role: "10", action: "110", type: "edit" },
    deleteBottomFooterPages: { role: "10", action: "110", type: "delete" },

    viewPageDocument: { role: "10", action: "111", type: "view" },
    addPageDocument: { role: "10", action: "111", type: "add" },
    editPageDocument: { role: "10", action: "111", type: "edit" },
    deletePageDocument: { role: "10", action: "111", type: "delete" },

    viewFooterContent: { role: "10", action: "112", type: "view" },
    addFooterContent: { role: "10", action: "112", type: "add" },
    editFooterContent: { role: "10", action: "112", type: "edit" },
    deleteFooterContent: { role: "10", action: "112", type: "delete" },

    
    // Admin Management
    viewRolesAndPermissions: { role: "70", action: "71", type: "view" },
    addRolesAndPermissions: { role: "70", action: "71", type: "add" },
    editRolesAndPermissions: { role: "70", action: "71", type: "edit" },
    deleteRolesAndPermissions: { role: "70", action: "71", type: "delete" },

    viewAdminUser: { role: "70", action: "72", type: "view" },
    addAdminUser: { role: "70", action: "72", type: "add" },
    editAdminUser: { role: "70", action: "72", type: "edit" },
    deleteAdminUser: { role: "70", action: "72", type: "delete" },

    viewRecoverAdminUser: { role: "70", action: "113", type: "view" },
    addRecoverAdminUser: { role: "70", action: "113", type: "add" },
    editRecoverAdminUser: { role: "70", action: "113", type: "edit" },
    deleteRecoverAdminUser: { role: "70", action: "113", type: "delete" },

    viewYearlyTarget: { role: "70", action: "114", type: "view" },
    addYearlyTarget: { role: "70", action: "114", type: "add" },
    editYearlyTarget: { role: "70", action: "114", type: "edit" },
    deleteYearlyTarget: { role: "70", action: "114", type: "delete" },


    // Settings Module
    viewStates: { role: "11", action: "49", type: "view" },
    addStates: { role: "11", action: "49", type: "add" },
    editStates: { role: "11", action: "49", type: "edit" },
    deleteStates: { role: "11", action: "49", type: "delete" },

    viewDistricts: { role: "11", action: "50", type: "view" },
    addDistricts: { role: "11", action: "50", type: "add" },
    editDistricts: { role: "11", action: "50", type: "edit" },
    deleteDistricts: { role: "11", action: "50", type: "delete" },

    viewCities: { role: "11", action: "51", type: "view" },
    addCities: { role: "11", action: "51", type: "add" },
    editCities: { role: "11", action: "51", type: "edit" },
    deleteCities: { role: "11", action: "51", type: "delete" },

    viewCities: { role: "11", action: "51", type: "view" },
    addCities: { role: "11", action: "51", type: "add" },
    editCities: { role: "11", action: "51", type: "edit" },
    deleteCities: { role: "11", action: "51", type: "delete" },

    viewSMSSetting: { role: "11", action: "52", type: "view" },
    editSMSSetting: { role: "11", action: "52", type: "edit" },

    viewEmailSetting: { role: "11", action: "53", type: "view" },
    editEmailSetting: { role: "11", action: "53", type: "edit" },

    viewPaymentSetting: { role: "11", action: "48", type: "view" },
    editPaymentSetting: { role: "11", action: "48", type: "edit" },

    viewConfiguration: { role: "11", action: "115", type: "view" },
    editConfiguration: { role: "11", action: "115", type: "edit" },


    // Reports
    viewDistrictTotalApplicationsReport: { role: "128", action: "131", type: "view" },
    viewDistrictPendingApplicationsReport: { role: "128", action: "132", type: "view" },
    viewDistrictDraftApplicationsReport: { role: "128", action: "133", type: "view" },
    viewDistrictAcceptedCertificateApplicationsReport: { role: "128", action: "134", type: "view" },
    viewDistrictRejectedApplicationsReport: { role: "128", action: "135", type: "view" },
    viewDistrictUnderReviewApplicationsReport: { role: "128", action: "136", type: "view" },
    viewDistrictYearlyTargetReport: { role: "128", action: "137", type: "view" },


    // Logs
    viewOTPLogs: { role: "129", action: "123", type: "view" },
    viewAdminLogs: { role: "129", action: "125", type: "view" },
    viewUserLogs: { role: "129", action: "126", type: "view" },
    viewEmailLogs: { role: "129", action: "127", type: "view" },


    // Travel Trade Users
    viewUserList: { role: "146", action: "147", type: "view" },
    editUserList: { role: "146", action: "147", type: "edit" },
    deleteUserList: { role: "146", action: "147", type: "delete" },

    viewUpdateDetailsRequest: { role: "146", action: "148", type: "view" },
    editUpdateDetailsRequest: { role: "146", action: "148", type: "edit" },
    deleteUpdateDetailsRequest: { role: "146", action: "148", type: "delete" },

    viewRecoverUser: { role: "146", action: "149", type: "view" },
    editRecoverUser: { role: "146", action: "149", type: "edit" },

};


export default PermissionChecker;
